import { createContext, useState, useContext } from "react";

const AcademicYearContext = createContext();

export const AcademicYearProvider = ({ children }) => {
  const [academicYearId, setAcademicYearId] = useState("");
  const [selectedYear, setSelectedYear] = useState(""); 

  return (
    <AcademicYearContext.Provider value={{ academicYearId, setAcademicYearId,selectedYear, setSelectedYear }}>
      {children}
    </AcademicYearContext.Provider>
  );
};

export const useAcademicYear = () => useContext(AcademicYearContext);
